'use client'

import { cn } from '@/lib/utils'
import { AnimatedNumber } from '@/components/ui/animated-number'

import { EASE, HAIRLINE, useReveal } from '@/components/page-kit'
import { HRMS } from './data'

/* The four authored figures, value and label, and nothing else — no invented
   sentence explaining each one. The digits are server-rendered at their true
   values and count up (shared AnimatedNumber) once the band is in view. */

export function HrmsMetrics() {
  const band = useReveal<HTMLDivElement>(0.2)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <div ref={band.ref} className={cn('border-t', HAIRLINE)}>
          <dl className="grid grid-cols-2 lg:grid-cols-4">
            {HRMS.stats.map((s, i) => (
              <div key={s.label} className="relative py-7 pr-6 sm:py-9">
                <span
                  aria-hidden
                  className="absolute bottom-0 top-0 w-px origin-top bg-border/70"
                  style={{
                    left: '-1px',
                    transform: band.shown ? 'scaleY(1)' : 'scaleY(0)',
                    transition: `transform 620ms ${EASE} ${i * 110}ms`,
                    opacity: i === 0 ? 0 : 1,
                  }}
                />

                <div
                  className="pl-4 sm:pl-6 lg:pl-8"
                  style={{
                    opacity: band.shown ? 1 : 0,
                    transform: band.shown ? 'none' : 'translateY(8px)',
                    transition: `opacity 520ms ${EASE} ${180 + i * 110}ms, transform 520ms ${EASE} ${180 + i * 110}ms`,
                  }}
                >
                  <dd className="font-heading text-4xl font-normal tabular-nums leading-none text-foreground sm:text-5xl">
                    <AnimatedNumber value={s.value} delay={180 + i * 110} />
                  </dd>
                  <dt className="mt-3 text-[13px] font-medium leading-snug text-muted-foreground sm:text-sm">
                    {s.label}
                  </dt>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  )
}
